import React, { useRef } from 'react';
import Slider from 'react-slick';
import AdditionalServicesCard from './AdditionalServicesCard';
import 'slick-carousel/slick/slick.css';
import useScrollObserver from '../../../../hooks/useScrollObserver';

const AdditionalServicesSlider = () => {
  const slider = useRef();
  const observerRef = useRef();

  const settings = {
    initialSlide: 0, // Ensure slider starts from the first slide
    infinite: true,
    speed: 300,
    swipe: true,
    slidesToShow: 5,
    slidesToScroll: 1,
    arrows: false,
    autoplay: false,
    responsive: [
      {
        breakpoint: 1080,
        settings: {
          variableWidth: true,
          slidesToShow: 1,
          dots: true,
          dotsClass: 'custom-dots',
          centerPadding: '15px',
        },
      },
      {
        breakpoint: 767,
        settings: {
          variableWidth: true,
          slidesToShow: 1,
          dots: true,
          dotsClass: 'custom-dots',
          centerPadding: '15px',
        },
      },
    ],
  };

  const handleScrollIntoView = () => {
    observerRef.current.classList.add('animate');
  };
  useScrollObserver(observerRef, handleScrollIntoView);

  return (
    <>
      <style>
        {`
          .additional-service-slider .slick-list {
              overflow: visible;
          }
          .slick-track {
            display: flex;
            align-items: center;  
          }
          .slick-slide {
            outline: none;
          }
          .slick-slide div {
            outline: none;
          }
          .custom-dots {
            display: flex !important;
            justify-content: center;
          }
          .custom-dots li {
            position: relative;
            margin: 0 3px;
            margin-top: 20px;
            width: 50px;
            height: 2px;
            background-color: #C4C4C4;
            overflow: hidden;
          }
          .additional-service-slider  .custom-dots li.slick-active{
            background-color:#D9A8E5;
          }
          .custom-dots li button {
            position: absolute;
            width: 100%;
            height: 100%;
            top: 0;
            left: 0;
            opacity: 0;
          }
        `}
      </style>
      <div ref={observerRef}>
        <Slider ref={slider} {...settings} className="additional-service-slider w-full z-10">
          <div className="block pr-[30px] pb-[48px] fade-in-from-bottom ease-out">
            <AdditionalServicesCard imgClass="animation-delay-400 ease-in" imageUrl="/images/seo/phone.webp" headerText="SEO Consulting" />
          </div>
          <div className="block pr-[30px] pb-[48px] fade-in-from-bottom animation-delay-200 ease-out">
            <AdditionalServicesCard imgClass="animation-delay-600 ease-in" imageUrl="/images/seo/notebook 1.png" headerText="Content Marketing" />
          </div>
          <div className="block pr-[30px] pb-[48px] fade-in-from-bottom animation-delay-400 ease-out">
            <AdditionalServicesCard
              imgClass="animation-delay-800 ease-in"
              imageUrl="/images/seo/notebook 3.png"
              headerText="Advanced Link Building"
            />
          </div>
          <div className="block pr-[30px] pb-[48px] fade-in-from-bottom animation-delay-600 ease-out">
            <a href="/paid-advertising-services" className="cursor-pointer">
              <AdditionalServicesCard imgClass="animation-delay-1000 ease-in" imageUrl="/images/seo/notebook 2.png" headerText="PPC Integration" />
            </a>
          </div>
          <div className="block pr-[30px] pb-[48px] fade-in-from-bottom animation-delay-800 ease-out">
            <AdditionalServicesCard
              imgClass="animation-delay-1200 ease-in"
              imageUrl="/images/seo/notebook 4.png"
              headerText="Reputation Management"
            />
          </div>
        </Slider>
      </div>
    </>
  );
};

export default AdditionalServicesSlider;
